const SPACE_BETWEEN = 0.5;
const GRID_LENGTH = 12;

const UnderlineType = {
    DEFAULT: 'Default',
    WELL_DONE: 'Done',
    BAD_WORK: 'Bad',
};

export { UnderlineType, SPACE_BETWEEN, GRID_LENGTH };
